// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1-XRU","icon":"SortAdornment_icon__2JOy8","up":"SortAdornment_up__3IORx","down":"SortAdornment_down__1D7_J","active":"SortAdornment_active__2LQEx"};